import { encodePathSegment } from "../utils/encode-path-segment";

// NOTE: NSAI-5827 — public, password-protected links for AI-generated pages.
// Machine-readable error codes the anonymous viewer branches on to tell an
// invalid link from a revoked/expired one and from a wrong password. Keep in
// sync with server PAGE_PUBLIC_SHARE_ERROR_CODES.
export const PAGE_PUBLIC_SHARE_ERROR_CODES = {
  NOT_FOUND: "PAGE_SHARE_NOT_FOUND",
  REVOKED: "PAGE_SHARE_REVOKED",
  EXPIRED: "PAGE_SHARE_EXPIRED",
  INVALID_PASSWORD: "PAGE_SHARE_INVALID_PASSWORD",
  // NOTE: The link is live but its password was regenerated after the viewer's
  // access token was minted — they need to re-enter the new password, they did
  // not get it wrong.
  PASSWORD_ROTATED: "PAGE_SHARE_PASSWORD_ROTATED",
} as const;

// NOTE: React Query key for the owner's view of a page's public link, scoped
// per page file so publishing one page never invalidates another's state.
export const PAGE_PUBLIC_SHARE_QUERY_KEY = "page-public-share";

// NOTE: Header carrying the share-access token minted at password verification.
// Must match PAGE_SHARE_ACCESS_TOKEN_HEADER on the server.
export const PAGE_SHARE_ACCESS_TOKEN_HEADER = "x-page-share-token";

// NOTE: Path of the anonymous viewer route. The server composes the absolute
// shareUrl from FRONTEND_URL + this path; the web client rebuilds it from its
// own origin so a custom domain or on-prem reverse proxy stays correct.
export const PAGE_PUBLIC_SHARE_VIEWER_PATH = "/shared/page";

// NOTE: API routes for the owner side and the anonymous side. Centralized so
// web and mobile cannot drift on a path.
export const pagePublicShareUrl = (fileUuid: string): string =>
  `/pages/${encodePathSegment(fileUuid)}/public-share`;

export const revokePagePublicShareUrl = (fileUuid: string): string =>
  `/pages/${encodePathSegment(fileUuid)}/public-share/revoke`;

export const sharedPageStatusUrl = (shareToken: string): string =>
  `/pages/shared/${encodePathSegment(shareToken)}`;

export const sharedPageVerifyUrl = (shareToken: string): string =>
  `/pages/shared/${encodePathSegment(shareToken)}/verify`;

export const sharedPageContentUrl = (shareToken: string): string =>
  `/pages/shared/${encodePathSegment(shareToken)}/content`;
